/*
 * @Author: your name
 * @Date: 2022-03-24 16:20:24
 * @LastEditTime: 2022-04-08 11:43:06
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \kares_pad\src\assets\scripts\setObjToString.js
 */
export function setObjToString(params) {
  let paramsData = '';
  let temp = [];
  for (let Key in params) {
    params[Key] !== undefined && temp.push(Key + "=" + formatParam(params[Key]));
  }
  paramsData = temp.sort().join("&");
  return paramsData;
}
// Object.keys(params).filter(t=>params[t]!=null).map(t=>t+"="+params[t]).join("&")
function formatParam(p){
  let r;
  switch (p) {
    case null:
    case '':
      r = '';
      break;
    default:
      r = p;
      break;
  }
  return r;
}
